import React, { useEffect, useState } from 'react'
import './widget-shell.css'

interface WidgetShellProps {
  debugMode: boolean
  debugPanel?: React.ReactNode
  children: React.ReactNode
}

export const WidgetShell: React.FC<WidgetShellProps> = ({
  debugMode,
  debugPanel,
  children,
}) => {
  const [isDebugOpen, setIsDebugOpen] = useState(true)

  useEffect(() => {
    setIsDebugOpen(debugMode)
  }, [debugMode])

  return (
    <div className="widget-shell">
      {debugMode && (
        <>
          <button
            type="button"
            className="widget-shell__debug-toggle"
            onClick={() => setIsDebugOpen((prev) => !prev)}
            aria-expanded={isDebugOpen}
            aria-controls="widget-debug-panel"
          >
            {isDebugOpen ? 'Hide Debug' : 'Show Debug'}
          </button>

          <button
            type="button"
            className={`widget-shell__debug-backdrop${isDebugOpen ? ' is-open' : ''}`}
            onClick={() => setIsDebugOpen(false)}
            aria-label="Close debug panel"
          />

          <aside
            id="widget-debug-panel"
            className={`widget-shell__debug${isDebugOpen ? ' is-open' : ''}`}
          >
            {debugPanel}
          </aside>
        </>
      )}

      <main className="widget-shell__chart">{children}</main>
    </div>
  )
}
